export default __webpack_public_path__ + "static/speaker1-f83ea8aef1080a8af73116f1838ffd7f.jpg";